import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { BiometriaService as BiometriaCoreService } from '@/core/api/sicom-api/registro/medico/biometria/biometria.service';
import { BiometriaRequest, BiometriaResponse } from '@/core/api/sicom-api/registro/medico/biometria/biometria.model';

@Injectable({ providedIn: 'root' })
/** Fachada de biometria do médico: delega ao service core e centraliza o tratamento de erro. */
export class BiometriaFeatureService extends CustomService {
    private readonly core = inject(BiometriaCoreService);

    buscar(params: Pessoa): Observable<BiometriaResponse[]> {
        return this.core.buscar(params).pipe(catchError(this.handleError));
    }

    converterWsqParaJpg(file: File): Observable<Blob> {
        return this.core.converterWsqParaJpg(file).pipe(catchError(this.handleError));
    }

    salvar(requests: BiometriaRequest[]): Observable<BiometriaResponse[]> {
        return this.core.salvar(requests).pipe(catchError(this.handleError));
    }
}
